import {
  unref,
} from 'vue';

import {
  CLIENT_I18N_INSTANCE,
} from './_state.ts';
import {
  I18N_NAMESPACE,
} from './constants.ts';

function joinKey(...parts: string[]) {
  return parts.filter(Boolean).join('.');
}

const translationCache = new Map<string, Map<string, string>>();

export function useLibraryI18n(componentScope?: string) {
  if (CLIENT_I18N_INSTANCE.instance === undefined) {
    throw new Error('The @qmulus/ui library was not registered with the app.');
  }
  const i18n = CLIENT_I18N_INSTANCE.instance;

  const base = componentScope
    ? joinKey(I18N_NAMESPACE, componentScope)
    : I18N_NAMESPACE;

  function scopedKey(key: string) {
    return joinKey(base, key);
  }

  function t(key: string, ...args: unknown[]): string {
    const fullKey = scopedKey(key);

    // Don't cache translations that use parameters/options/pluralization.
    if (args.length > 0) {
      return i18n.global.t(fullKey, ...args);
    }

    const locale = unref(i18n.global.locale);

    let localeCache = translationCache.get(locale);

    if (localeCache === undefined) {
      localeCache = new Map();
      translationCache.set(locale, localeCache);
    }

    const cached = localeCache.get(fullKey);

    if (cached !== undefined) {
      return cached;
    }

    const translated = i18n.global.t(fullKey);

    localeCache.set(fullKey, translated);

    return translated;
  }

  return {
    t,
    te: (key: string) => i18n.global.te(scopedKey(key)),
    key: scopedKey,
  };
}

export default useLibraryI18n;
